// Only checks wheter the sku contains numbers so we can avoid receiving 500 errors from api responses
const isValidSku = partNumber => {
  const partNumberDigits = partNumber?.toLowerCase().startsWith('tuc') ? partNumber.substring(3) : partNumber
  return !Number.isNaN(Number(partNumberDigits))
}

export { isValidSku }
